'use client';

import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import { clsx } from 'clsx';
import React from 'react';
import ButterBlogLink from '~/components/Links/ButterBlogLink';

interface Props {
  children: React.ReactNode;
  mobile: boolean;
}

const BlogMenu: React.FC<Props> = ({ mobile, children }) => {
  return (
    <Popover className="relative">
      <PopoverButton
        className={clsx(
          'bg-turf-green-500 px-2 py-1.5 text-white',
          'rounded-l md:rounded-l-none md:rounded-r',
        )}
      >
        <Bars3Icon className="h-7 w-7" />
      </PopoverButton>

      <PopoverPanel
        className={clsx(
          'absolute -top-4 z-10 w-screen rounded bg-white p-4 shadow-lg',
          mobile ? '-left-4' : '-right-4 max-w-lg',
        )}
      >
        <div className="mb-4 flex justify-between md:flex-row-reverse">
          <PopoverButton>
            <XMarkIcon className="h-7 w-7" />
          </PopoverButton>

          <div>
            <ButterBlogLink className="font-semibold">Blog Home</ButterBlogLink>
          </div>
        </div>

        {children}
      </PopoverPanel>
    </Popover>
  );
};

export default BlogMenu;
